var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tTabs',{attrs:{"selectType":_vm.selectType,"typeData":_vm.typeData},on:{"update:selectType":function($event){_vm.selectType=$event},"update:select-type":function($event){_vm.selectType=$event}}}),(_vm.selectType === '1')?_c('platApply'):_vm._e(),(_vm.selectType === '2')?_c('platQuery'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }